<template>
  <div class="page-home">
    <PageHeader />

    <!-- Hero -->
    <section class="hero">
      <div class="hero-deco"></div>
      <div class="wrap hero-grid">
        <div>
          <span class="hero-kicker"><i></i>云南省民政厅正式登记注册 · 省级供应链权威组织</span>
          <h1>云南供应链<br><em>第四方综合服务平台</em></h1>
          <div class="slogan"><b>聚链</b> · <b>补链</b> · <b>强链</b> · <b>融链</b></div>
          <p class="hero-sub">整合生产制造、商贸、全场景物流、金融、服务业资源，构建协会成员"内循环"，推动南亚东南亚业务拓展，助力云南打造"一带一路"供应链枢纽。</p>
          <div class="hero-actions">
            <button class="btn btn-primary" @click="go('/join-process')">申请入会 →</button>
            <button class="btn btn-ghost" @click="go('/news-list')">了解协会</button>
          </div>
        </div>
        <aside class="hero-card">
          <h3>协会数据 · YSCA DATA</h3>
          <div class="stat-grid">
            <div class="stat"><b>200<i>+</i></b><span>会员企业</span></div>
            <div class="stat"><b>12<i>年</i></b><span>协会历程</span></div>
            <div class="stat"><b>50<i>+</i></b><span>年度活动</span></div>
            <div class="stat"><b>5<i>大领域</i></b><span>产业覆盖</span></div>
          </div>
          <div class="notice" v-if="hotNewsList.length"><i>荐</i><span class="notice-text">{{ hotNewsList[0].title }}</span></div>
        </aside>
      </div>
    </section>

    <!-- 最新资讯 -->
    <section class="section">
      <div class="wrap">
        <div class="sec-head">
          <div>
            <div class="cn">最新资讯</div>
            <div class="en">Latest News</div>
          </div>
          <a class="more" @click="go('/news-list')">查看全部 →</a>
        </div>
        <div class="news-layout" v-if="hotNewsList.length">
          <article class="feature-news" @click="goArticle(hotNewsList[0])">
            <svg class="hex" viewBox="0 0 120 138"><path d="M60 4 112 34v68L60 132 8 102V34z" fill="#fff"/></svg>
            <div class="body">
              <span class="tag">头条</span>
              <h3>{{ hotNewsList[0].title }}</h3>
              <p>{{ formatDate(hotNewsList[0].createdTime) }} · {{ hotNewsList[0].subtitle || '协会动态' }}</p>
            </div>
          </article>
          <div class="news-list">
            <div class="news-item" v-for="item in listNews" :key="item.id" @click="goArticle(item)">
              <div class="date-chip"><b>{{ dayOf(item.createdTime) }}</b><span>{{ yearMonthOf(item.createdTime) }}</span></div>
              <div>
                <div class="title">{{ item.title }}</div>
                <div class="sub">{{ item.subtitle || '协会动态' }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="news-empty" v-else>暂无资讯</div>
      </div>
    </section>

    <!-- 功能模块 -->
    <section class="section modules">
      <div class="wrap">
        <div class="sec-head">
          <div>
            <div class="cn">功能模块</div>
            <div class="en">Functional Modules</div>
          </div>
        </div>
        <div class="module-grid">
          <div class="module-card" v-for="m in modules" :key="m.title" @click="m.path && go(m.path)">
            <div class="module-icon">{{ m.icon }}</div>
            <b>{{ m.title }}</b>
            <p>{{ m.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 留言建议 -->
    <section class="section message-section">
      <div class="wrap message-grid">
        <div class="message-intro">
          <div class="cn">留言建议</div>
          <div class="en">Leave a Message</div>
          <p>如果您有意向加入协会、洽谈合作，或对协会工作有意见建议，欢迎给我们留言，秘书处会尽快与您联系。</p>
          <ul class="contact-list">
            <li><b>服务热线</b>{{ siteConfig.phone }}</li>
            <li><b>协会邮箱</b>{{ siteConfig.email }}</li>
            <li><b>协会地址</b>{{ siteConfig.address }}</li>
          </ul>
        </div>
        <MessageBoard class="message-form"/>
      </div>
    </section>

    <FooterComponent />
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import PageHeader from "@/components/PageHeader";
import FooterComponent from "@/components/FooterComponent";
import MessageBoard from "@/components/MessageBoard.vue";
import { siteConfig } from "@/composables/useSiteConfig.js";
import { getArticlePage } from "@/api/articleApi.js";

const router = useRouter();

const hotNewsList = ref([]);

const listNews = computed(() => hotNewsList.value.slice(1, 7));

const modules = [
  { icon: "📄", title: "通知文件", desc: "企业文化的延伸，推动可持续发展", path: "/RelatedFunctions/fileNotice" },
  { icon: "🏅", title: "会员展示", desc: "展示会员的成就与贡献", path: "/membership-list" },
  { icon: "📈", title: "经济运行", desc: "分析经济运行的各项指标", path: "/news-list" },
  { icon: "🌏", title: "国际交流", desc: "促进国际间的交流与合作", path: "/news-list" },
  { icon: "🔬", title: "质量标准", desc: "确保产品和服务的质量", path: "/news-list" },
  { icon: "⚖️", title: "政策法规", desc: "了解最新的政策法规动态", path: "/RelatedFunctions/fileNotice" },
  { icon: "📰", title: "协会刊物", desc: "发布协会的最新动态与信息", path: "/news-list" },
  { icon: "🔗", title: "协会友链", desc: "展示与其他协会的合作关系", path: "" },
];

function go(path) {
  router.push(path);
}

function goArticle(item) {
  if (item && item.id) {
    router.push({ name: "ArticleView", params: { articleId: item.id } });
  }
}

function getHotNews() {
  getArticlePage({
    pageNum: 1,
    pageSize: 7,
    isAsc: "desc",
    orderByColumn: "createdTime",
    articleTypeCode: "home-hot-news",
  }).then((res) => {
    if (res && res.rows && res.rows.length) {
      hotNewsList.value = res.rows;
    } else {
      // 热点资讯为空时回退到协会动态
      getArticlePage({
        pageNum: 1,
        pageSize: 7,
        isAsc: "desc",
        orderByColumn: "createdTime",
        articleTypeCode: "association-dynamics",
      }).then((res2) => {
        if (res2 && res2.rows) {
          hotNewsList.value = res2.rows;
        }
      });
    }
  });
}

function pad(n) {
  return n < 10 ? "0" + n : "" + n;
}

function parseTime(t) {
  return t ? new Date(t) : null;
}

function dayOf(t) {
  const d = parseTime(t);
  return d ? d.getDate() : "--";
}

function yearMonthOf(t) {
  const d = parseTime(t);
  return d ? d.getFullYear() + "." + pad(d.getMonth() + 1) : "";
}

function formatDate(t) {
  const d = parseTime(t);
  if (!d) return "";
  return d.getFullYear() + "年" + (d.getMonth() + 1) + "月" + d.getDate() + "日";
}

onMounted(() => {
  getHotNews();
});
</script>

<style scoped>
.page-home {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg);
}

/* ---------- Hero ---------- */
.hero {
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #eaf1fc 0%, #f7faff 55%, #eef4fd 100%);
}

.hero::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='138' viewBox='0 0 120 138'%3E%3Cpath d='M60 4 112 34v68L60 132 8 102V34z' fill='none' stroke='%231d5bd6' stroke-opacity='.08' stroke-width='2'/%3E%3C/svg%3E");
  background-size: 120px 138px;
}

.hero-deco {
  position: absolute;
  right: -60px;
  top: -60px;
  width: 340px;
  height: 340px;
  border-radius: 50%;
  background: radial-gradient(circle at 35% 35%, rgba(29, 91, 214, .14), transparent 70%);
}

.hero-grid {
  position: relative;
  display: grid;
  grid-template-columns: 1.15fr .85fr;
  gap: 48px;
  align-items: center;
  padding-top: 72px;
  padding-bottom: 72px;
}

.hero-kicker {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  border: 1px solid var(--line);
  color: var(--color-primary-600);
  font-size: 13px;
  font-weight: 600;
  padding: 6px 14px;
  border-radius: 999px;
  box-shadow: var(--shadow-sm);
}

.hero-kicker i {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--color-accent);
}

.hero h1 {
  margin-top: 20px;
  font-size: 52px;
  line-height: 1.18;
  color: var(--color-primary-900);
  letter-spacing: 2px;
}

.hero h1 em {
  font-style: normal;
  color: var(--color-primary-500);
}

.slogan {
  margin-top: 14px;
  font-size: 22px;
  letter-spacing: 6px;
  color: var(--text-2);
}

.slogan b {
  color: var(--color-primary-500);
}

.hero-sub {
  margin-top: 18px;
  max-width: 560px;
  color: var(--text-3);
  font-size: 15px;
}

.hero-actions {
  margin-top: 32px;
  display: flex;
  gap: 14px;
}

.hero-card {
  background: rgba(255, 255, 255, .85);
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
  box-shadow: var(--shadow-lg);
  padding: 26px;
}

.hero-card h3 {
  font-size: 15px;
  color: var(--color-primary-600);
  letter-spacing: 2px;
  margin-bottom: 14px;
}

.stat-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.stat {
  background: #fff;
  border: 1px solid var(--line);
  border-radius: var(--r-md);
  padding: 16px 18px;
}

.stat b {
  display: block;
  font-size: 28px;
  color: var(--color-primary-500);
  line-height: 1.2;
}

.stat b i {
  font-style: normal;
  font-size: 14px;
  color: var(--text-3);
  margin-left: 2px;
}

.stat span {
  font-size: 13px;
  color: var(--text-3);
}

.notice {
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px dashed var(--line);
  font-size: 13px;
  color: var(--text-2);
  display: flex;
  gap: 8px;
  align-items: center;
}

.notice i {
  font-style: normal;
  color: var(--color-accent);
  font-weight: 700;
  flex: none;
}

.notice-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ---------- Section ---------- */
.section {
  padding: 34px 0;
}

.page-home .sec-head {
  margin-bottom: 20px;
}

/* ---------- 最新资讯 ---------- */
.news-layout {
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 24px;
}

.feature-news {
  position: relative;
  border-radius: var(--r-lg);
  overflow: hidden;
  min-height: 380px;
  background: linear-gradient(160deg, var(--color-primary-600), var(--color-primary-900));
  box-shadow: var(--shadow-md);
  cursor: pointer;
}

.feature-news .hex {
  position: absolute;
  right: -40px;
  bottom: -46px;
  width: 260px;
  height: 260px;
  opacity: .16;
}

.feature-news .body {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 28px;
  background: linear-gradient(transparent, rgba(10, 26, 64, .85));
}

.feature-news .tag {
  display: inline-block;
  background: var(--color-accent);
  color: #fff;
  font-size: 12px;
  padding: 3px 10px;
  border-radius: 4px;
  letter-spacing: 1px;
}

.feature-news h3 {
  color: #fff;
  font-size: 24px;
  margin-top: 12px;
  line-height: 1.4;
}

.feature-news p {
  color: #c3d2ef;
  font-size: 14px;
  margin-top: 8px;
}

.news-list {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
  box-shadow: var(--shadow-sm);
  padding: 10px 22px;
}

.news-item {
  display: flex;
  gap: 18px;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid var(--line);
  cursor: pointer;
  transition: background var(--fast);
}

.news-item:last-child {
  border-bottom: none;
}

.news-item:hover .title {
  color: var(--color-primary-500);
}

.date-chip {
  flex: none;
  width: 58px;
  text-align: center;
  background: var(--color-primary-50);
  border-radius: var(--r-sm);
  padding: 6px 0;
}

.date-chip b {
  display: block;
  font-size: 20px;
  color: var(--color-primary-500);
  line-height: 1.1;
}

.date-chip span {
  font-size: 11px;
  color: var(--text-3);
}

.news-item .title {
  font-size: 15px;
  color: var(--text-1);
  line-height: 1.45;
  transition: color var(--fast);
}

.news-item .sub {
  font-size: 13px;
  color: var(--text-3);
  margin-top: 2px;
}

.news-empty {
  text-align: center;
  color: var(--text-3);
  padding: 80px 0;
}

/* ---------- 功能模块 ---------- */
.modules {
  background: linear-gradient(180deg, #fff, #f2f6fd);
}

.module-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
}

.module-card {
  background: #fff;
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
  padding: 26px 22px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: all var(--normal);
  box-shadow: var(--shadow-sm);
}

.module-card::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, var(--color-primary-500), transparent);
  opacity: 0;
  transition: opacity var(--fast);
}

.module-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-md);
  border-color: var(--color-primary-100);
}

.module-card:hover::after {
  opacity: 1;
}

.module-icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  font-size: 24px;
  margin-bottom: 14px;
  background: var(--color-primary-50);
}

.module-card b {
  font-size: 17px;
  color: var(--color-primary-900);
}

.module-card p {
  font-size: 13px;
  color: var(--text-3);
  margin-top: 6px;
}

/* ---------- 移动端 ---------- */
@media (max-width: 960px) {
  .hero-grid {
    grid-template-columns: 1fr;
    padding-top: 48px;
    padding-bottom: 48px;
  }

  .hero h1 {
    font-size: 36px;
  }

  .news-layout {
    grid-template-columns: 1fr;
  }

  .module-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
/* ===== 留言建议 ===== */
.message-section {
  background: linear-gradient(180deg, #f2f6fd, #eaf1fc);
  padding-bottom: 44px;
}

.message-grid {
  display: grid;
  grid-template-columns: 1fr 1.1fr;
  gap: 48px;
  align-items: center;
}

.message-intro .cn {
  font-size: 28px;
  font-weight: 700;
  color: var(--color-primary-900);
  letter-spacing: 2px;
}

.message-intro .en {
  font-size: 13px;
  color: var(--text-3);
  letter-spacing: 3px;
  text-transform: uppercase;
  margin-top: 4px;
}

.message-intro p {
  margin-top: 18px;
  font-size: 14.5px;
  color: var(--text-2);
  line-height: 1.9;
  max-width: 440px;
}

.contact-list {
  list-style: none;
  margin: 22px 0 0;
  padding: 0;
}

.contact-list li {
  font-size: 14px;
  color: var(--text-2);
  line-height: 2.2;
}

.contact-list li b {
  display: inline-block;
  width: 76px;
  color: var(--color-primary-600);
  font-weight: 600;
}

@media (max-width: 900px) {
  .message-grid {
    grid-template-columns: 1fr;
    gap: 28px;
  }
}
</style>
